import { connect } from 'react-redux';

import { openModal } from '../../../ducks/modals_manager/slice';

const connector = connect(null, {
  openModal,
});

export default connector;
